import { createFileRoute } from '@tanstack/react-router'
import { Service } from '@/components/settings-route/ticket/service/index.jsx'

export const Route = createFileRoute('/_auth/settings/tickets/service')({
  component: Service,
})
